import { useVerifiedOffer, useVerifiedOfferBin } from '../state';

import shallow from 'zustand/shallow';

/* 
  this hook is used to get bank offer (bin number, last4 bin number and expiry).
*/

export const useBankOfferParams = () => {
  const verifiedOffer = useVerifiedOffer(s => s.verifiedOffer, shallow);
  const [
    verifiedOfferBin,
    verifiedOfferLast4Bin,
    verifiedExpiryMonth,
    verifiedExpiryYear,
  ] = useVerifiedOfferBin(
    s => [
      s.verifiedOfferBin,
      s.verifiedOfferLast4Bin,
      s.verifiedExpiryMonth,
      s.verifiedExpiryYear,
    ],
    shallow
  );
  const getBankOfferParams = () =>
    verifiedOffer?.isBankOfferApplied || verifiedOffer?.isCardOfferApplied
      ? {
          bin: verifiedOfferBin,
          last4: verifiedOfferLast4Bin,
          expiryMonth: verifiedExpiryMonth,
          expiryYear: verifiedExpiryYear,
        }
      : {};

  return { getBankOfferParams };
};
